'use client';

import React, { FC, useEffect, useState } from 'react';
import CustomImage from '@/src/v2/components/Image/CustomImage';
import classNames from 'classnames';

import style from './category-item-v2.module.scss';
import { useSignedUrl } from '@/src/v2/hooks/useSignedUrl/useSignedUrl';
import LogoIcon from '@/src/v2/assets/icons/LogoIcon';
import Link from 'next/link';
import { ICategoryTag } from '@/src/v2/service/v2/graphql/generated/gql-api.generated';

type Props = {
  imgUrl: string;
  name: string;
  description: string;
  id?: string;
  isSelected?: boolean;
  totalView?: string | number;
  onSelectClick: (id: string) => void;
  categotyTag?: ICategoryTag[];
};

const ImageOrIcon = ({
  thumbnailUrl,
  imgError,
  setImgError,
  name,
  isSelected,
}) => {
  const { url: panelImageUrl } = useSignedUrl(thumbnailUrl, []);
  const timeStamp = new Date().getTime();
  return (
    <div
      className={classNames(style['category-item__image'], {
        [style['category-item__image--fallback']]: imgError,
        [style['category-item__image--default']]: !panelImageUrl,
        [style['category-item__image__selected']]: isSelected,
      })}
    >
      {isSelected && (
        <div className={style['category-item__container--overlay']}>
          <LogoIcon />
        </div>
      )}
      {panelImageUrl && !imgError ? (
        <CustomImage
          imageUrl={`${panelImageUrl}?${timeStamp}`} // alias of "src"
          alt={`${name} - view more`}
          fill={true}
          onError={(e) => {
            setImgError(true);
          }}
          onLoadingComplete={(result) => {
            if (result.naturalWidth === 0) {
              // Broken image
              setImgError(true);
            }
          }}
          style={{
            objectFit: 'cover',
          }}
        />
      ) : (
        <div className={style['category-item__image--default']}>
          <LogoIcon isThumbnail={true} />
        </div>
      )}
    </div>
  );
};

const CategoryItemV2: FC<Props> = ({
  imgUrl,
  name,
  description,
  id,
  isSelected,
  onSelectClick,
  categotyTag,
  totalView = 0,
}) => {
  const [imgError, setImgError] = useState<boolean>(false);
  // const [isSelected, setIsSelected] = useState<boolean>(false);

  return (
    <div
      className={classNames(style['category-item__container'], {
        [style['category-item__container__selected']]: isSelected,
      })}
      onClick={() => {
        onSelectClick(id);
      }}
    >
      <Link href="#">
        <ImageOrIcon
          thumbnailUrl={imgUrl}
          imgError={imgError}
          setImgError={setImgError}
          name={name}
          isSelected={isSelected}
        />
      </Link>
      <div className={style['category-item__info']}>
        <div className={style['category-item__title']}>{name}</div>
        {/* <div className={style['category-item__description']}>{description}</div> */}
        <div title="" className={style['category-item__description']}>
          <span title="">{totalView} viewers</span>
        </div>
        {categotyTag && categotyTag.length > 0 && (
          <>
            <div className={style['category-item__type']}>
              <>
                {categotyTag.map((tag) => {
                  return (
                    <>
                      {tag?.eventType != null && (
                        <span title={`Tag : ${tag?.eventType?.name}`}>
                          {tag?.eventType?.name}
                        </span>
                      )}
                    </>
                  );
                })}
              </>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default CategoryItemV2;
